var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 86,
    viewBox: "0 0 75 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6445 32.459L33.2688 43.8801H23.6445V32.459Z",
    fill: "url(#paint0_linear_2006_4556)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9699 47.1986L70.82 82.0586C70.6125 83.8014 69.3557 85.0966 67.8726 85.0966H8.58529C7.1022 85.0966 5.84534 83.8014 5.63786 82.0586L0.0297861 34.9542C-0.223184 32.8277 1.16738 30.9277 2.97722 30.9277H21.2864C22.7695 30.9277 24.0263 32.223 24.2338 33.9654L24.9687 40.1341C25.1762 41.8768 26.4331 43.1721 27.9162 43.1721H72.0231C73.8323 43.1721 75.2232 45.0721 74.9702 47.1986H74.9699Z",
    fill: "url(#paint1_linear_2006_4556)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2665 69.5471H16.1921C15.9505 69.547 15.7173 69.4424 15.536 69.2528C15.3548 69.0633 15.238 68.8018 15.2076 68.5174L14.6562 63.3365C14.6386 63.1708 14.651 63.0025 14.6925 62.8429C14.7339 62.6832 14.8035 62.5359 14.8966 62.4106C14.9897 62.2853 15.1042 62.185 15.2325 62.1162C15.3608 62.0474 15.4999 62.0118 15.6407 62.0117H60.8179C60.9587 62.0118 61.0978 62.0474 61.2261 62.1162C61.3544 62.185 61.4688 62.2853 61.5619 62.4106C61.6551 62.5359 61.7246 62.6832 61.7661 62.8429C61.8076 63.0025 61.8199 63.1708 61.8024 63.3365L61.251 68.5174C61.2205 68.8018 61.1038 69.0633 60.9225 69.2528C60.7413 69.4424 60.508 69.547 60.2665 69.5471Z",
    fill: "#FFC97A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.762 15.9783L61.2767 25.5973M52.2403 5.90485L49.0457 22.2262L52.2403 5.90485ZM29.9961 4.19117L36.7329 18.8326L29.9961 4.19117Z",
    stroke: "#FFC97A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2006_4556",
    x1: 30.0032,
    y1: 45.7126,
    x2: 16.3983,
    y2: 34.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2006_4556",
    x1: 37.4999,
    y1: 30.9277,
    x2: 37.4999,
    y2: 85.0966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLight);
export default __webpack_public_path__ + "static/media/empty-light.a2b1af4f280d610444529bf76533d2f6.svg";
export { ForwardRef as ReactComponent };